// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"InputLabel_inputLabel__w9o7R","inputLabelRequired":"InputLabel_inputLabelRequired__oDm8K"};